import { h } from 'preact';
import style from './style.css';

const Header = () => (
	<header class={style.header}>
		<h1>whattimeisitrightnow.scav</h1>
	</header>
);

export default Header;
